/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: KX-6C77UY1fL

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { DialogClose } from "@plasmicpkgs/radix-ui";
import ModalCloseButton from "../../ModalCloseButton"; // plasmic-import: mUrFb8Eka3V0/component
import { ApiMutationProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/ApiProvider/ApiMutationProvider"; // plasmic-import: appzeORup7Cy/codeComponent
import { FormProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/form/FormProvider"; // plasmic-import: R4jbURjT8nMH/codeComponent
import { FormControlProvider } from "@myevaluations/myevals-plasmic-utils/dist/code-components/form/FormControlProvider"; // plasmic-import: v9MLUrEpQF_1/codeComponent
import TextInput from "../../TextInput"; // plasmic-import: kx7Qgd3B-3Xa/component
import Textarea from "../../Textarea"; // plasmic-import: JRA4OayO7Ias/component
import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import SpinnerIcon from "../../SpinnerIcon"; // plasmic-import: 0R7aXYvaG7Fy/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicContactModalForm.module.css"; // plasmic-import: KX-6C77UY1fL/css

import SearchSvgIcon from "./icons/PlasmicIcon__SearchSvg"; // plasmic-import: 4h8B6qj-XIZa/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon
import Group2Icon from "./icons/PlasmicIcon__Group2"; // plasmic-import: CsZShyIyOiIf/icon

import { zod as __fn_zod } from "@myevaluations/myevals-plasmic-utils/dist/custom-functions/zod"; // plasmic-import: zod/customFunction

createPlasmicElementProxy;

export type PlasmicContactModalForm__VariantMembers = {};
export type PlasmicContactModalForm__VariantsArgs = {};
type VariantPropType = keyof PlasmicContactModalForm__VariantsArgs;
export const PlasmicContactModalForm__VariantProps =
  new Array<VariantPropType>();

export type PlasmicContactModalForm__ArgsType = {
  isSubmitted?: boolean;
  onIsSubmittedChange?: (val: string) => void;
};
type ArgPropType = keyof PlasmicContactModalForm__ArgsType;
export const PlasmicContactModalForm__ArgProps = new Array<ArgPropType>(
  "isSubmitted",
  "onIsSubmittedChange"
);

export type PlasmicContactModalForm__OverridesType = {
  formModal?: Flex__<"div">;
  fill?: Flex__<"div">;
  top?: Flex__<"div">;
  header?: Flex__<"header">;
  left?: Flex__<"div">;
  link?: Flex__<"h4">;
  dialogClose?: Flex__<typeof DialogClose>;
  modalCloseButton?: Flex__<typeof ModalCloseButton>;
  intro?: Flex__<"div">;
  title?: Flex__<"h2">;
  desc?: Flex__<"p">;
  send?: Flex__<typeof ApiMutationProvider>;
  contactForm?: Flex__<typeof FormProvider>;
  form?: Flex__<"form">;
  inputsRow?: Flex__<"div">;
  nameWorkCol?: Flex__<"div">;
  nameProvider?: Flex__<typeof FormControlProvider>;
  nameInput?: Flex__<"div">;
  nameLabel?: Flex__<"div">;
  name?: Flex__<typeof TextInput>;
  nameErrorContainer?: Flex__<"div">;
  error?: Flex__<"span">;
  emailProvider?: Flex__<typeof FormControlProvider>;
  emailInput?: Flex__<"div">;
  emailLabel?: Flex__<"div">;
  email?: Flex__<typeof TextInput>;
  emailErrorContainer?: Flex__<"div">;
  error2?: Flex__<"span">;
  institutionPhoneCol?: Flex__<"div">;
  institutionProvider?: Flex__<typeof FormControlProvider>;
  institutionInput?: Flex__<"div">;
  institutionLabels?: Flex__<"div">;
  label4?: Flex__<"div">;
  label5?: Flex__<"label">;
  institution?: Flex__<typeof TextInput>;
  institutionErrorContainer?: Flex__<"div">;
  error5?: Flex__<"span">;
  phoneProvider?: Flex__<typeof FormControlProvider>;
  phoneInput?: Flex__<"div">;
  label6?: Flex__<"div">;
  label7?: Flex__<"div">;
  label8?: Flex__<"label">;
  phone?: Flex__<typeof TextInput>;
  phoneErrorContainer?: Flex__<"div">;
  error6?: Flex__<"span">;
  messageProvider?: Flex__<typeof FormControlProvider>;
  messageTextarea?: Flex__<"div">;
  messageLabel?: Flex__<"div">;
  label10?: Flex__<"div">;
  message?: Flex__<typeof Textarea>;
  messageErrorContainer?: Flex__<"div">;
  error3?: Flex__<"span">;
  sendMessageBtn?: Flex__<typeof Button>;
  spinnerIcon?: Flex__<typeof SpinnerIcon>;
  footer?: Flex__<"div">;
  sales?: Flex__<"div">;
  icon2?: Flex__<"div">;
  text8?: Flex__<"div">;
  title2?: Flex__<"h5">;
  paragraph?: Flex__<"div">;
  desc2?: Flex__<"p">;
  desc3?: Flex__<"p">;
  button2?: Flex__<typeof Button>;
  support?: Flex__<"div">;
  icon4?: Flex__<"div">;
  text9?: Flex__<"div">;
  title5?: Flex__<"h5">;
  paragraph2?: Flex__<"div">;
  desc5?: Flex__<"p">;
  desc6?: Flex__<"p">;
  desc7?: Flex__<"div">;
  company?: Flex__<"div">;
  icon5?: Flex__<"div">;
  text?: Flex__<"div">;
  title4?: Flex__<"h5">;
  paragraph3?: Flex__<"div">;
  desc4?: Flex__<"div">;
  desc8?: Flex__<"div">;
  desc9?: Flex__<"p">;
  icon3?: Flex__<"div">;
  layout112?: Flex__<"div">;
};

export interface DefaultContactModalFormProps {
  isSubmitted?: boolean;
  onIsSubmittedChange?: (val: string) => void;
  className?: string;
}

const $$ = {
  zod: __fn_zod
};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicContactModalForm__RenderFunc(props: {
  variants: PlasmicContactModalForm__VariantsArgs;
  args: PlasmicContactModalForm__ArgsType;
  overrides: PlasmicContactModalForm__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "name.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $ctx.nameProvider.field.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "email.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $ctx.emailProvider.field.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "institution.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $ctx.institutionProvider.field.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "phone.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $ctx.phoneProvider.field.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "message.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          (() => {
            try {
              return $ctx.messageProvider.field.value;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()
      },
      {
        path: "isSubmitted",
        type: "writable",
        variableType: "boolean",

        valueProp: "isSubmitted",
        onChangeProp: "onIsSubmittedChange"
      },
      {
        path: "isFormSubmitting",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"formModal"}
      data-plasmic-override={overrides.formModal}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.formModal
      )}
    >
      <div
        data-plasmic-name={"fill"}
        data-plasmic-override={overrides.fill}
        className={classNames(projectcss.all, sty.fill)}
      >
        <div
          data-plasmic-name={"top"}
          data-plasmic-override={overrides.top}
          className={classNames(projectcss.all, sty.top)}
        >
          <header
            data-plasmic-name={"header"}
            data-plasmic-override={overrides.header}
            className={classNames(projectcss.all, sty.header)}
          >
            <div
              data-plasmic-name={"left"}
              data-plasmic-override={overrides.left}
              className={classNames(projectcss.all, sty.left)}
            >
              <h4
                data-plasmic-name={"link"}
                data-plasmic-override={overrides.link}
                className={classNames(
                  projectcss.all,
                  projectcss.h4,
                  projectcss.__wab_text,
                  sty.link
                )}
              >
                {"Contact"}
              </h4>
            </div>
            <DialogClose
              data-plasmic-name={"dialogClose"}
              data-plasmic-override={overrides.dialogClose}
              className={classNames("__wab_instance", sty.dialogClose)}
            >
              <ModalCloseButton
                data-plasmic-name={"modalCloseButton"}
                data-plasmic-override={overrides.modalCloseButton}
                className={classNames("__wab_instance", sty.modalCloseButton)}
              />
            </DialogClose>
          </header>
          <div
            data-plasmic-name={"intro"}
            data-plasmic-override={overrides.intro}
            className={classNames(projectcss.all, sty.intro)}
          >
            <h2
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames(
                projectcss.all,
                projectcss.h2,
                projectcss.__wab_text,
                sty.title
              )}
            >
              {"Get in Touch"}
            </h2>
            <p
              data-plasmic-name={"desc"}
              data-plasmic-override={overrides.desc}
              className={classNames(
                projectcss.all,
                projectcss.p,
                projectcss.__wab_text,
                sty.desc
              )}
            >
              {
                "After submission, expect a response within one business day for sales requests, \nappointments etc. Critical issues receive attention within three hours."
              }
            </p>
          </div>
        </div>
        <ApiMutationProvider
          data-plasmic-name={"send"}
          data-plasmic-override={overrides.send}
          alertOnError={true}
          className={classNames("__wab_instance", sty.send)}
          method={"POST"}
          name={"sendContact"}
          onError={async error => {
            const $steps = {};

            $steps["updateIsFormSubmitting"] = true
              ? (() => {
                  const actionArgs = {
                    variable: {
                      objRoot: $state,
                      variablePath: ["isFormSubmitting"]
                    },
                    operation: 0,
                    value: false
                  };
                  return (({ variable, value, startIndex, deleteCount }) => {
                    if (!variable) {
                      return;
                    }
                    const { objRoot, variablePath } = variable;

                    $stateSet(objRoot, variablePath, value);
                    return value;
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["updateIsFormSubmitting"] != null &&
              typeof $steps["updateIsFormSubmitting"] === "object" &&
              typeof $steps["updateIsFormSubmitting"].then === "function"
            ) {
              $steps["updateIsFormSubmitting"] =
                await $steps["updateIsFormSubmitting"];
            }
          }}
          onLoad={async data => {
            const $steps = {};

            $steps["updateIsFormSubmitting"] = true
              ? (() => {
                  const actionArgs = {
                    variable: {
                      objRoot: $state,
                      variablePath: ["isFormSubmitting"]
                    },
                    operation: 0,
                    value: false
                  };
                  return (({ variable, value, startIndex, deleteCount }) => {
                    if (!variable) {
                      return;
                    }
                    const { objRoot, variablePath } = variable;

                    $stateSet(objRoot, variablePath, value);
                    return value;
                  })?.apply(null, [actionArgs]);
                })()
              : undefined;
            if (
              $steps["updateIsFormSubmitting"] != null &&
              typeof $steps["updateIsFormSubmitting"] === "object" &&
              typeof $steps["updateIsFormSubmitting"].then === "function"
            ) {
              $steps["updateIsFormSubmitting"] =
                await $steps["updateIsFormSubmitting"];
            }
          }}
          path={"/New/Api.ashx?path=/marketing/contact-form"}
          throwOnError={true}
        >
          <DataCtxReader__>
            {$ctx => (
              <FormProvider
                data-plasmic-name={"contactForm"}
                data-plasmic-override={overrides.contactForm}
                className={classNames("__wab_instance", sty.contactForm)}
                contextName={"contactForm"}
                mode={"all"}
                reValidateMode={"onChange"}
                zodValidationSchema={(() => {
                  try {
                    return (() => {
                      const z = $$.zod();
                      const schema = z.object({
                        name: z.string().nonempty({ message: "Required" }),
                        email: z.string().email({
                          message:
                            $state.email.value === ""
                              ? "Required"
                              : "Invalid email address"
                        }),
                        institution: z.string().optional(),
                        phone: z
                          .string()
                          .refine(
                            value => {
                              const trimmedValue = value.replace(/\s/g, "");
                              return (
                                trimmedValue === "" ||
                                /^\d+$/.test(trimmedValue)
                              );
                            },
                            { message: "Only digits allowed" }
                          )
                          .optional(),
                        message: z.string().nonempty({ message: "Required" })
                      });
                      return schema;
                    })();
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
              >
                <DataCtxReader__>
                  {$ctx => (
                    <form
                      data-plasmic-name={"form"}
                      data-plasmic-override={overrides.form}
                      className={classNames(projectcss.all, sty.form)}
                      onSubmit={async event => {
                        const $steps = {};

                        $steps["runCode"] = !$state.isFormSubmitting
                          ? (() => {
                              const actionArgs = {
                                customFunction: async () => {
                                  return (() => {
                                    event.preventDefault();
                                    const onFinish = () => {
                                      const onSubmit = values => {
                                        $state.isFormSubmitting = true;
                                        $ctx.sendContact
                                          .trigger({
                                            body: {
                                              name: values.name,
                                              email: values.email,
                                              institution: values.institution,
                                              phone: values.phone
                                                ? values.phone.replace(
                                                    /\s/g,
                                                    ""
                                                  )
                                                : undefined,
                                              message: values.message
                                            }
                                          })
                                          .then(() => {
                                            $state.isSubmitted = true;
                                          })
                                          .catch(() => {
                                            $ctx.toast.show({
                                              id: "1",
                                              type: "error",
                                              title: "Server Error",
                                              description:
                                                "Your form hasn\u2019t been submitted. Try again."
                                            });
                                          });
                                      };
                                      const onError = () => {
                                        $ctx.toast.show({
                                          id: "1",
                                          type: "error",
                                          title: "Incomplete Form",
                                          description:
                                            "Fix errors and missing data marked in red and submit again."
                                        });
                                      };
                                      return $ctx.contactForm.handleSubmit(
                                        onSubmit,
                                        onError
                                      )();
                                    };
                                    return onFinish();
                                  })();
                                }
                              };
                              return (({ customFunction }) => {
                                return customFunction();
                              })?.apply(null, [actionArgs]);
                            })()
                          : undefined;
                        if (
                          $steps["runCode"] != null &&
                          typeof $steps["runCode"] === "object" &&
                          typeof $steps["runCode"].then === "function"
                        ) {
                          $steps["runCode"] = await $steps["runCode"];
                        }
                      }}
                    >
                      <div
                        data-plasmic-name={"inputsRow"}
                        data-plasmic-override={overrides.inputsRow}
                        className={classNames(projectcss.all, sty.inputsRow)}
                      >
                        <div
                          data-plasmic-name={"nameWorkCol"}
                          data-plasmic-override={overrides.nameWorkCol}
                          className={classNames(
                            projectcss.all,
                            sty.nameWorkCol
                          )}
                        >
                          <FormControlProvider
                            data-plasmic-name={"nameProvider"}
                            data-plasmic-override={overrides.nameProvider}
                            className={classNames(
                              "__wab_instance",
                              sty.nameProvider
                            )}
                            contextName={"nameProvider"}
                            fieldName={"name"}
                            formControl={(() => {
                              try {
                                return $ctx.contactForm.control;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return undefined;
                                }
                                throw e;
                              }
                            })()}
                          >
                            <DataCtxReader__>
                              {$ctx => (
                                <div
                                  data-plasmic-name={"nameInput"}
                                  data-plasmic-override={overrides.nameInput}
                                  className={classNames(
                                    projectcss.all,
                                    sty.nameInput
                                  )}
                                >
                                  <div
                                    data-plasmic-name={"nameLabel"}
                                    data-plasmic-override={overrides.nameLabel}
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.__wab_text,
                                      sty.nameLabel
                                    )}
                                  >
                                    {"Name"}
                                  </div>
                                  {(() => {
                                    const child$Props = {
                                      "aria-label": "Name",
                                      "aria-labelledby": ``,
                                      className: classNames(
                                        "__wab_instance",
                                        sty.name
                                      ),
                                      invalid: (() => {
                                        try {
                                          return $ctx.nameProvider.fieldState
                                            .invalid;
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return [];
                                          }
                                          throw e;
                                        }
                                      })(),
                                      name: "name",
                                      onChange: async (...eventArgs: any) => {
                                        ((...eventArgs) => {
                                          generateStateOnChangeProp($state, [
                                            "name",
                                            "value"
                                          ])(
                                            (e => e.target?.value).apply(
                                              null,
                                              eventArgs
                                            )
                                          );
                                        }).apply(null, eventArgs);

                                        if (
                                          eventArgs.length > 1 &&
                                          eventArgs[1] &&
                                          eventArgs[1]._plasmic_state_init_
                                        ) {
                                          return;
                                        }

                                        (async event => {
                                          const $steps = {};

                                          $steps["runCode"] = true
                                            ? (() => {
                                                const actionArgs = {
                                                  customFunction: async () => {
                                                    return $ctx.nameProvider.field.onChange(
                                                      event.target.value
                                                    );
                                                  }
                                                };
                                                return (({
                                                  customFunction
                                                }) => {
                                                  return customFunction();
                                                })?.apply(null, [actionArgs]);
                                              })()
                                            : undefined;
                                          if (
                                            $steps["runCode"] != null &&
                                            typeof $steps["runCode"] ===
                                              "object" &&
                                            typeof $steps["runCode"].then ===
                                              "function"
                                          ) {
                                            $steps["runCode"] =
                                              await $steps["runCode"];
                                          }
                                        }).apply(null, eventArgs);
                                      },
                                      placeholder: "John Smith",
                                      required: false,
                                      size: "medium",
                                      startIcon: (
                                        <SearchSvgIcon
                                          className={classNames(
                                            projectcss.all,
                                            sty.svg__zwRad
                                          )}
                                          role={"img"}
                                        />
                                      ),

                                      type: "text",
                                      value:
                                        generateStateValueProp($state, [
                                          "name",
                                          "value"
                                        ]) ?? ""
                                    };

                                    initializePlasmicStates(
                                      $state,
                                      [
                                        {
                                          name: "name.value",
                                          initFunc: ({
                                            $props,
                                            $state,
                                            $queries,
                                            $q
                                          }) =>
                                            (() => {
                                              try {
                                                return $ctx.nameProvider.field
                                                  .value;
                                              } catch (e) {
                                                if (
                                                  e instanceof TypeError ||
                                                  e?.plasmicType ===
                                                    "PlasmicUndefinedDataError"
                                                ) {
                                                  return undefined;
                                                }
                                                throw e;
                                              }
                                            })()
                                        }
                                      ],
                                      []
                                    );
                                    return (
                                      <TextInput
                                        data-plasmic-name={"name"}
                                        data-plasmic-override={overrides.name}
                                        {...child$Props}
                                      />
                                    );
                                  })()}
                                  <div
                                    data-plasmic-name={"nameErrorContainer"}
                                    data-plasmic-override={
                                      overrides.nameErrorContainer
                                    }
                                    className={classNames(
                                      projectcss.all,
                                      sty.nameErrorContainer
                                    )}
                                  >
                                    {(() => {
                                      try {
                                        return $ctx.nameProvider.fieldState
                                          .invalid;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return false;
                                        }
                                        throw e;
                                      }
                                    })() ? (
                                      <span
                                        data-plasmic-name={"error"}
                                        data-plasmic-override={overrides.error}
                                        className={classNames(
                                          projectcss.all,
                                          projectcss.span,
                                          projectcss.__wab_text,
                                          sty.error
                                        )}
                                      >
                                        <React.Fragment>
                                          {
                                            $ctx.nameProvider.fieldState.error
                                              .message
                                          }
                                        </React.Fragment>
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                              )}
                            </DataCtxReader__>
                          </FormControlProvider>
                          <FormControlProvider
                            data-plasmic-name={"emailProvider"}
                            data-plasmic-override={overrides.emailProvider}
                            className={classNames(
                              "__wab_instance",
                              sty.emailProvider
                            )}
                            contextName={"emailProvider"}
                            fieldName={"email"}
                            formControl={(() => {
                              try {
                                return $ctx.contactForm.control;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return undefined;
                                }
                                throw e;
                              }
                            })()}
                          >
                            <DataCtxReader__>
                              {$ctx => (
                                <div
                                  data-plasmic-name={"emailInput"}
                                  data-plasmic-override={overrides.emailInput}
                                  className={classNames(
                                    projectcss.all,
                                    sty.emailInput
                                  )}
                                >
                                  <div
                                    data-plasmic-name={"emailLabel"}
                                    data-plasmic-override={overrides.emailLabel}
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.__wab_text,
                                      sty.emailLabel
                                    )}
                                  >
                                    {"Work Email"}
                                  </div>
                                  {(() => {
                                    const child$Props = {
                                      "aria-label": "Email",
                                      "aria-labelledby": ``,
                                      className: classNames(
                                        "__wab_instance",
                                        sty.email
                                      ),
                                      invalid: (() => {
                                        try {
                                          return $ctx.emailProvider.fieldState
                                            .invalid;
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return [];
                                          }
                                          throw e;
                                        }
                                      })(),
                                      name: "email",
                                      onChange: async (...eventArgs: any) => {
                                        ((...eventArgs) => {
                                          generateStateOnChangeProp($state, [
                                            "email",
                                            "value"
                                          ])(
                                            (e => e.target?.value).apply(
                                              null,
                                              eventArgs
                                            )
                                          );
                                        }).apply(null, eventArgs);

                                        if (
                                          eventArgs.length > 1 &&
                                          eventArgs[1] &&
                                          eventArgs[1]._plasmic_state_init_
                                        ) {
                                          return;
                                        }

                                        (async event => {
                                          const $steps = {};

                                          $steps["runCode"] = true
                                            ? (() => {
                                                const actionArgs = {
                                                  customFunction: async () => {
                                                    return $ctx.emailProvider.field.onChange(
                                                      event.target.value
                                                    );
                                                  }
                                                };
                                                return (({
                                                  customFunction
                                                }) => {
                                                  return customFunction();
                                                })?.apply(null, [actionArgs]);
                                              })()
                                            : undefined;
                                          if (
                                            $steps["runCode"] != null &&
                                            typeof $steps["runCode"] ===
                                              "object" &&
                                            typeof $steps["runCode"].then ===
                                              "function"
                                          ) {
                                            $steps["runCode"] =
                                              await $steps["runCode"];
                                          }
                                        }).apply(null, eventArgs);
                                      },
                                      placeholder: "john.smith@institution.com",
                                      size: "medium",
                                      type: "email",
                                      value:
                                        generateStateValueProp($state, [
                                          "email",
                                          "value"
                                        ]) ?? ""
                                    };

                                    initializePlasmicStates(
                                      $state,
                                      [
                                        {
                                          name: "email.value",
                                          initFunc: ({
                                            $props,
                                            $state,
                                            $queries,
                                            $q
                                          }) =>
                                            (() => {
                                              try {
                                                return $ctx.emailProvider.field
                                                  .value;
                                              } catch (e) {
                                                if (
                                                  e instanceof TypeError ||
                                                  e?.plasmicType ===
                                                    "PlasmicUndefinedDataError"
                                                ) {
                                                  return undefined;
                                                }
                                                throw e;
                                              }
                                            })()
                                        }
                                      ],
                                      []
                                    );
                                    return (
                                      <TextInput
                                        data-plasmic-name={"email"}
                                        data-plasmic-override={overrides.email}
                                        {...child$Props}
                                      />
                                    );
                                  })()}
                                  <div
                                    data-plasmic-name={"emailErrorContainer"}
                                    data-plasmic-override={
                                      overrides.emailErrorContainer
                                    }
                                    className={classNames(
                                      projectcss.all,
                                      sty.emailErrorContainer
                                    )}
                                  >
                                    {(() => {
                                      try {
                                        return $ctx.emailProvider.fieldState
                                          .invalid;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return false;
                                        }
                                        throw e;
                                      }
                                    })() ? (
                                      <span
                                        data-plasmic-name={"error2"}
                                        data-plasmic-override={overrides.error2}
                                        className={classNames(
                                          projectcss.all,
                                          projectcss.span,
                                          projectcss.__wab_text,
                                          sty.error2
                                        )}
                                      >
                                        <React.Fragment>
                                          {
                                            $ctx.emailProvider.fieldState.error
                                              .message
                                          }
                                        </React.Fragment>
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                              )}
                            </DataCtxReader__>
                          </FormControlProvider>
                        </div>
                        <div
                          data-plasmic-name={"institutionPhoneCol"}
                          data-plasmic-override={overrides.institutionPhoneCol}
                          className={classNames(
                            projectcss.all,
                            sty.institutionPhoneCol
                          )}
                        >
                          <FormControlProvider
                            data-plasmic-name={"institutionProvider"}
                            data-plasmic-override={
                              overrides.institutionProvider
                            }
                            className={classNames(
                              "__wab_instance",
                              sty.institutionProvider
                            )}
                            contextName={"institutionProvider"}
                            fieldName={"institution"}
                            formControl={(() => {
                              try {
                                return $ctx.contactForm.control;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return undefined;
                                }
                                throw e;
                              }
                            })()}
                            rules={{ required: false }}
                          >
                            <DataCtxReader__>
                              {$ctx => (
                                <div
                                  data-plasmic-name={"institutionInput"}
                                  data-plasmic-override={
                                    overrides.institutionInput
                                  }
                                  className={classNames(
                                    projectcss.all,
                                    sty.institutionInput
                                  )}
                                >
                                  <div
                                    data-plasmic-name={"institutionLabels"}
                                    data-plasmic-override={
                                      overrides.institutionLabels
                                    }
                                    className={classNames(
                                      projectcss.all,
                                      sty.institutionLabels
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"label4"}
                                      data-plasmic-override={overrides.label4}
                                      className={classNames(
                                        projectcss.all,
                                        projectcss.__wab_text,
                                        sty.label4
                                      )}
                                    >
                                      {"Institution"}
                                    </div>
                                    <label
                                      data-plasmic-name={"label5"}
                                      data-plasmic-override={overrides.label5}
                                      className={classNames(
                                        projectcss.all,
                                        projectcss.__wab_text,
                                        sty.label5
                                      )}
                                    >
                                      {"Optional"}
                                    </label>
                                  </div>
                                  {(() => {
                                    const child$Props = {
                                      "aria-label": "Institution",
                                      "aria-labelledby": ``,
                                      className: classNames(
                                        "__wab_instance",
                                        sty.institution
                                      ),
                                      invalid: (() => {
                                        try {
                                          return $ctx.institutionProvider
                                            .fieldState.invalid;
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return [];
                                          }
                                          throw e;
                                        }
                                      })(),
                                      name: "institution",
                                      onChange: async (...eventArgs: any) => {
                                        ((...eventArgs) => {
                                          generateStateOnChangeProp($state, [
                                            "institution",
                                            "value"
                                          ])(
                                            (e => e.target?.value).apply(
                                              null,
                                              eventArgs
                                            )
                                          );
                                        }).apply(null, eventArgs);

                                        if (
                                          eventArgs.length > 1 &&
                                          eventArgs[1] &&
                                          eventArgs[1]._plasmic_state_init_
                                        ) {
                                          return;
                                        }

                                        (async event => {
                                          const $steps = {};

                                          $steps["runCode"] = true
                                            ? (() => {
                                                const actionArgs = {
                                                  customFunction: async () => {
                                                    return $ctx.institutionProvider.field.onChange(
                                                      event.target.value
                                                    );
                                                  }
                                                };
                                                return (({
                                                  customFunction
                                                }) => {
                                                  return customFunction();
                                                })?.apply(null, [actionArgs]);
                                              })()
                                            : undefined;
                                          if (
                                            $steps["runCode"] != null &&
                                            typeof $steps["runCode"] ===
                                              "object" &&
                                            typeof $steps["runCode"].then ===
                                              "function"
                                          ) {
                                            $steps["runCode"] =
                                              await $steps["runCode"];
                                          }
                                        }).apply(null, eventArgs);
                                      },
                                      placeholder: "ABC Medical University",
                                      size: "medium",
                                      type: "text",
                                      value:
                                        generateStateValueProp($state, [
                                          "institution",
                                          "value"
                                        ]) ?? ""
                                    };

                                    initializePlasmicStates(
                                      $state,
                                      [
                                        {
                                          name: "institution.value",
                                          initFunc: ({
                                            $props,
                                            $state,
                                            $queries,
                                            $q
                                          }) =>
                                            (() => {
                                              try {
                                                return $ctx.institutionProvider
                                                  .field.value;
                                              } catch (e) {
                                                if (
                                                  e instanceof TypeError ||
                                                  e?.plasmicType ===
                                                    "PlasmicUndefinedDataError"
                                                ) {
                                                  return undefined;
                                                }
                                                throw e;
                                              }
                                            })()
                                        }
                                      ],
                                      []
                                    );
                                    return (
                                      <TextInput
                                        data-plasmic-name={"institution"}
                                        data-plasmic-override={
                                          overrides.institution
                                        }
                                        {...child$Props}
                                      />
                                    );
                                  })()}
                                  <div
                                    data-plasmic-name={
                                      "institutionErrorContainer"
                                    }
                                    data-plasmic-override={
                                      overrides.institutionErrorContainer
                                    }
                                    className={classNames(
                                      projectcss.all,
                                      sty.institutionErrorContainer
                                    )}
                                  >
                                    {(() => {
                                      try {
                                        return $ctx.institutionProvider
                                          .fieldState.invalid;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return false;
                                        }
                                        throw e;
                                      }
                                    })() ? (
                                      <span
                                        data-plasmic-name={"error5"}
                                        data-plasmic-override={overrides.error5}
                                        className={classNames(
                                          projectcss.all,
                                          projectcss.span,
                                          projectcss.__wab_text,
                                          sty.error5
                                        )}
                                      >
                                        <React.Fragment>
                                          {
                                            $ctx.institutionProvider.fieldState
                                              .error.message
                                          }
                                        </React.Fragment>
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                              )}
                            </DataCtxReader__>
                          </FormControlProvider>
                          <FormControlProvider
                            data-plasmic-name={"phoneProvider"}
                            data-plasmic-override={overrides.phoneProvider}
                            className={classNames(
                              "__wab_instance",
                              sty.phoneProvider
                            )}
                            contextName={"phoneProvider"}
                            fieldName={"phone"}
                            formControl={(() => {
                              try {
                                return $ctx.contactForm.control;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return undefined;
                                }
                                throw e;
                              }
                            })()}
                            rules={{ required: false }}
                          >
                            <DataCtxReader__>
                              {$ctx => (
                                <div
                                  data-plasmic-name={"phoneInput"}
                                  data-plasmic-override={overrides.phoneInput}
                                  className={classNames(
                                    projectcss.all,
                                    sty.phoneInput
                                  )}
                                >
                                  <div
                                    data-plasmic-name={"label6"}
                                    data-plasmic-override={overrides.label6}
                                    className={classNames(
                                      projectcss.all,
                                      sty.label6
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"label7"}
                                      data-plasmic-override={overrides.label7}
                                      className={classNames(
                                        projectcss.all,
                                        projectcss.__wab_text,
                                        sty.label7
                                      )}
                                    >
                                      {"Phone"}
                                    </div>
                                    <label
                                      data-plasmic-name={"label8"}
                                      data-plasmic-override={overrides.label8}
                                      className={classNames(
                                        projectcss.all,
                                        projectcss.__wab_text,
                                        sty.label8
                                      )}
                                    >
                                      {"Optional"}
                                    </label>
                                  </div>
                                  {(() => {
                                    const child$Props = {
                                      "aria-label": "Phone number",
                                      "aria-labelledby": ``,
                                      className: classNames(
                                        "__wab_instance",
                                        sty.phone
                                      ),
                                      invalid: (() => {
                                        try {
                                          return $ctx.phoneProvider.fieldState
                                            .invalid;
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return [];
                                          }
                                          throw e;
                                        }
                                      })(),
                                      name: "phone",
                                      onChange: async (...eventArgs: any) => {
                                        ((...eventArgs) => {
                                          generateStateOnChangeProp($state, [
                                            "phone",
                                            "value"
                                          ])(
                                            (e => e.target?.value).apply(
                                              null,
                                              eventArgs
                                            )
                                          );
                                        }).apply(null, eventArgs);

                                        if (
                                          eventArgs.length > 1 &&
                                          eventArgs[1] &&
                                          eventArgs[1]._plasmic_state_init_
                                        ) {
                                          return;
                                        }

                                        (async event => {
                                          const $steps = {};

                                          $steps["runCode"] = true
                                            ? (() => {
                                                const actionArgs = {
                                                  customFunction: async () => {
                                                    return $ctx.phoneProvider.field.onChange(
                                                      event.target.value
                                                    );
                                                  }
                                                };
                                                return (({
                                                  customFunction
                                                }) => {
                                                  return customFunction();
                                                })?.apply(null, [actionArgs]);
                                              })()
                                            : undefined;
                                          if (
                                            $steps["runCode"] != null &&
                                            typeof $steps["runCode"] ===
                                              "object" &&
                                            typeof $steps["runCode"].then ===
                                              "function"
                                          ) {
                                            $steps["runCode"] =
                                              await $steps["runCode"];
                                          }
                                        }).apply(null, eventArgs);
                                      },
                                      placeholder: "000 0000 0000",
                                      showPrefix: true,
                                      size: "medium",
                                      type: "tel",
                                      value:
                                        generateStateValueProp($state, [
                                          "phone",
                                          "value"
                                        ]) ?? ""
                                    };

                                    initializePlasmicStates(
                                      $state,
                                      [
                                        {
                                          name: "phone.value",
                                          initFunc: ({
                                            $props,
                                            $state,
                                            $queries,
                                            $q
                                          }) =>
                                            (() => {
                                              try {
                                                return $ctx.phoneProvider.field
                                                  .value;
                                              } catch (e) {
                                                if (
                                                  e instanceof TypeError ||
                                                  e?.plasmicType ===
                                                    "PlasmicUndefinedDataError"
                                                ) {
                                                  return undefined;
                                                }
                                                throw e;
                                              }
                                            })()
                                        }
                                      ],
                                      []
                                    );
                                    return (
                                      <TextInput
                                        data-plasmic-name={"phone"}
                                        data-plasmic-override={overrides.phone}
                                        {...child$Props}
                                      />
                                    );
                                  })()}
                                  <div
                                    data-plasmic-name={"phoneErrorContainer"}
                                    data-plasmic-override={
                                      overrides.phoneErrorContainer
                                    }
                                    className={classNames(
                                      projectcss.all,
                                      sty.phoneErrorContainer
                                    )}
                                  >
                                    {(() => {
                                      try {
                                        return $ctx.phoneProvider.fieldState
                                          .invalid;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return false;
                                        }
                                        throw e;
                                      }
                                    })() ? (
                                      <span
                                        data-plasmic-name={"error6"}
                                        data-plasmic-override={overrides.error6}
                                        className={classNames(
                                          projectcss.all,
                                          projectcss.span,
                                          projectcss.__wab_text,
                                          sty.error6
                                        )}
                                      >
                                        <React.Fragment>
                                          {
                                            $ctx.phoneProvider.fieldState.error
                                              .message
                                          }
                                        </React.Fragment>
                                      </span>
                                    ) : null}
                                  </div>
                                </div>
                              )}
                            </DataCtxReader__>
                          </FormControlProvider>
                        </div>
                      </div>
                      <FormControlProvider
                        data-plasmic-name={"messageProvider"}
                        data-plasmic-override={overrides.messageProvider}
                        className={classNames(
                          "__wab_instance",
                          sty.messageProvider
                        )}
                        contextName={"messageProvider"}
                        fieldName={"message"}
                        formControl={(() => {
                          try {
                            return $ctx.contactForm.control;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <DataCtxReader__>
                          {$ctx => (
                            <div
                              data-plasmic-name={"messageTextarea"}
                              data-plasmic-override={overrides.messageTextarea}
                              className={classNames(
                                projectcss.all,
                                sty.messageTextarea
                              )}
                            >
                              <div
                                data-plasmic-name={"messageLabel"}
                                data-plasmic-override={overrides.messageLabel}
                                className={classNames(
                                  projectcss.all,
                                  sty.messageLabel
                                )}
                              >
                                <div
                                  data-plasmic-name={"label10"}
                                  data-plasmic-override={overrides.label10}
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.__wab_text,
                                    sty.label10
                                  )}
                                >
                                  {"Message"}
                                </div>
                              </div>
                              {(() => {
                                const child$Props = {
                                  ariaLabel: "Message",
                                  ariaLabelledby: ``,
                                  className: classNames(
                                    "__wab_instance",
                                    sty.message
                                  ),
                                  invalid: (() => {
                                    try {
                                      return $ctx.messageProvider.fieldState
                                        .invalid;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return [];
                                      }
                                      throw e;
                                    }
                                  })(),
                                  name: "message",
                                  onValueChange: async (...eventArgs: any) => {
                                    generateStateOnChangeProp($state, [
                                      "message",
                                      "value"
                                    ]).apply(null, eventArgs);

                                    if (
                                      eventArgs.length > 1 &&
                                      eventArgs[1] &&
                                      eventArgs[1]._plasmic_state_init_
                                    ) {
                                      return;
                                    }

                                    (async val => {
                                      const $steps = {};

                                      $steps["runCode"] = true
                                        ? (() => {
                                            const actionArgs = {
                                              customFunction: async () => {
                                                return $ctx.messageProvider.field.onChange(
                                                  val
                                                );
                                              }
                                            };
                                            return (({ customFunction }) => {
                                              return customFunction();
                                            })?.apply(null, [actionArgs]);
                                          })()
                                        : undefined;
                                      if (
                                        $steps["runCode"] != null &&
                                        typeof $steps["runCode"] === "object" &&
                                        typeof $steps["runCode"].then ===
                                          "function"
                                      ) {
                                        $steps["runCode"] =
                                          await $steps["runCode"];
                                      }
                                    }).apply(null, eventArgs);
                                  },
                                  size: "medium",
                                  value: generateStateValueProp($state, [
                                    "message",
                                    "value"
                                  ])
                                };

                                initializePlasmicStates(
                                  $state,
                                  [
                                    {
                                      name: "message.value",
                                      initFunc: ({
                                        $props,
                                        $state,
                                        $queries,
                                        $q
                                      }) =>
                                        (() => {
                                          try {
                                            return $ctx.messageProvider.field
                                              .value;
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return undefined;
                                            }
                                            throw e;
                                          }
                                        })()
                                    }
                                  ],
                                  []
                                );
                                return (
                                  <Textarea
                                    data-plasmic-name={"message"}
                                    data-plasmic-override={overrides.message}
                                    {...child$Props}
                                  />
                                );
                              })()}
                              <div
                                data-plasmic-name={"messageErrorContainer"}
                                data-plasmic-override={
                                  overrides.messageErrorContainer
                                }
                                className={classNames(
                                  projectcss.all,
                                  sty.messageErrorContainer
                                )}
                              >
                                {(() => {
                                  try {
                                    return $ctx.messageProvider.fieldState
                                      .invalid;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return false;
                                    }
                                    throw e;
                                  }
                                })() ? (
                                  <span
                                    data-plasmic-name={"error3"}
                                    data-plasmic-override={overrides.error3}
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.span,
                                      projectcss.__wab_text,
                                      sty.error3
                                    )}
                                  >
                                    <React.Fragment>
                                      {
                                        $ctx.messageProvider.fieldState.error
                                          .message
                                      }
                                    </React.Fragment>
                                  </span>
                                ) : null}
                              </div>
                            </div>
                          )}
                        </DataCtxReader__>
                      </FormControlProvider>
                      <Button
                        data-plasmic-name={"sendMessageBtn"}
                        data-plasmic-override={overrides.sendMessageBtn}
                        className={classNames(
                          "__wab_instance",
                          sty.sendMessageBtn
                        )}
                        color={"primary"}
                        size={"large"}
                        submitsForm={true}
                      >
                        {(() => {
                          try {
                            return !$state.isFormSubmitting;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return true;
                            }
                            throw e;
                          }
                        })() ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__invbI
                            )}
                          >
                            {"Send message"}
                          </div>
                        ) : null}
                        {(() => {
                          try {
                            return $state.isFormSubmitting;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return false;
                            }
                            throw e;
                          }
                        })() ? (
                          <SpinnerIcon
                            data-plasmic-name={"spinnerIcon"}
                            data-plasmic-override={overrides.spinnerIcon}
                            className={classNames(
                              "__wab_instance",
                              sty.spinnerIcon
                            )}
                            light={true}
                          />
                        ) : null}
                      </Button>
                    </form>
                  )}
                </DataCtxReader__>
              </FormProvider>
            )}
          </DataCtxReader__>
        </ApiMutationProvider>
      </div>
      <div
        data-plasmic-name={"footer"}
        data-plasmic-override={overrides.footer}
        className={classNames(projectcss.all, sty.footer)}
      >
        <div
          data-plasmic-name={"sales"}
          data-plasmic-override={overrides.sales}
          className={classNames(projectcss.all, sty.sales)}
        >
          <div
            data-plasmic-name={"icon2"}
            data-plasmic-override={overrides.icon2}
            className={classNames(projectcss.all, sty.icon2)}
          >
            <PlasmicImg__
              alt={""}
              className={classNames(sty.img__onE5R)}
              displayHeight={"24px"}
              displayMaxHeight={"none"}
              displayMaxWidth={"100%"}
              displayMinHeight={"0"}
              displayMinWidth={"0"}
              displayWidth={"24px"}
              loader={"plasmic"}
              loading={"lazy"}
              src={{
                src: "https://site-assets.plasmic.app/cf4043d629c31720084d030bec8e84f7.svg",
                fullWidth: 24,
                fullHeight: 24,
                aspectRatio: 1
              }}
            />
          </div>
          <div
            data-plasmic-name={"text8"}
            data-plasmic-override={overrides.text8}
            className={classNames(projectcss.all, sty.text8)}
          >
            <h5
              data-plasmic-name={"title2"}
              data-plasmic-override={overrides.title2}
              className={classNames(
                projectcss.all,
                projectcss.h5,
                projectcss.__wab_text,
                sty.title2
              )}
            >
              {"Sales"}
            </h5>
            <div
              data-plasmic-name={"paragraph"}
              data-plasmic-override={overrides.paragraph}
              className={classNames(projectcss.all, sty.paragraph)}
            >
              <p
                data-plasmic-name={"desc2"}
                data-plasmic-override={overrides.desc2}
                className={classNames(
                  projectcss.all,
                  projectcss.p,
                  projectcss.__wab_text,
                  sty.desc2
                )}
              >
                {hasVariant(globalVariants, "mobile", "tabletPortrait") ? (
                  <React.Fragment>
                    <React.Fragment>{"Email: "}</React.Fragment>
                    {
                      <PlasmicLink__
                        aria-label={"Mail our sales department"}
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__bzIj5
                        )}
                        component={Link}
                        href={"mailto:sales@myevaluations.com"}
                        legacyBehavior={false}
                        platform={"nextjs"}
                      >
                        {hasVariant(globalVariants, "mobile", "tabletPortrait")
                          ? "sales@myevaluations.com"
                          : "sales@myevaluations.com"}
                      </PlasmicLink__>
                    }
                    <React.Fragment>{"\nPhone: "}</React.Fragment>
                    {
                      <PlasmicLink__
                        aria-label={"Call us"}
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__flqLt
                        )}
                        component={Link}
                        href={"tel:866-422-0554"}
                        legacyBehavior={false}
                        platform={"nextjs"}
                      >
                        {hasVariant(globalVariants, "mobile", "tabletPortrait")
                          ? "(866) 422-0554"
                          : "(866) 422-0554"}
                      </PlasmicLink__>
                    }
                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <React.Fragment>{"Email: "}</React.Fragment>
                    {
                      <PlasmicLink__
                        aria-label={"Mail our sales department"}
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__bzIj5
                        )}
                        component={Link}
                        href={"mailto:sales@myevaluations.com"}
                        legacyBehavior={false}
                        platform={"nextjs"}
                      >
                        {hasVariant(globalVariants, "mobile", "tabletPortrait")
                          ? "sales@myevaluations.com"
                          : "sales@myevaluations.com"}
                      </PlasmicLink__>
                    }
                    <React.Fragment>{"\nPhone: "}</React.Fragment>
                    {
                      <PlasmicLink__
                        aria-label={"Call us"}
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__flqLt
                        )}
                        component={Link}
                        href={"tel:866-422-0554"}
                        legacyBehavior={false}
                        platform={"nextjs"}
                      >
                        {hasVariant(globalVariants, "mobile", "tabletPortrait")
                          ? "(866) 422-0554"
                          : "(866) 422-0554"}
                      </PlasmicLink__>
                    }
                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                )}
              </p>
              <p
                data-plasmic-name={"desc3"}
                data-plasmic-override={overrides.desc3}
                className={classNames(
                  projectcss.all,
                  projectcss.p,
                  projectcss.__wab_text,
                  sty.desc3
                )}
              >
                {"Available Mon-Fri at 8 am-5 pm EST."}
              </p>
            </div>
            <Button
              data-plasmic-name={"button2"}
              data-plasmic-override={overrides.button2}
              className={classNames("__wab_instance", sty.button2)}
              color={"gray"}
              link={
                "https://calendly.com/dmelamed/request-a-demo?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=087fb3"
              }
              size={"small"}
              target={true}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___2ZFhw
                )}
              >
                {"Request demo"}
              </div>
            </Button>
          </div>
        </div>
        <div
          data-plasmic-name={"support"}
          data-plasmic-override={overrides.support}
          className={classNames(projectcss.all, sty.support)}
        >
          {(
            hasVariant(globalVariants, "mobile", "tabletPortrait")
              ? true
              : false
          ) ? (
            <div
              data-plasmic-name={"icon4"}
              data-plasmic-override={overrides.icon4}
              className={classNames(projectcss.all, sty.icon4)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__guQs)}
                displayHeight={"24px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"24px"}
                loader={"plasmic"}
                loading={"lazy"}
                src={{
                  src: "https://site-assets.plasmic.app/31df71954f14255f8956c411d2a10457.svg",
                  fullWidth: 24,
                  fullHeight: 24,
                  aspectRatio: 1
                }}
              />
            </div>
          ) : null}
          <div
            data-plasmic-name={"text9"}
            data-plasmic-override={overrides.text9}
            className={classNames(projectcss.all, sty.text9)}
          >
            <h5
              data-plasmic-name={"title5"}
              data-plasmic-override={overrides.title5}
              className={classNames(
                projectcss.all,
                projectcss.h5,
                projectcss.__wab_text,
                sty.title5
              )}
            >
              {"Support"}
            </h5>
            <div
              data-plasmic-name={"paragraph2"}
              data-plasmic-override={overrides.paragraph2}
              className={classNames(projectcss.all, sty.paragraph2)}
            >
              <p
                data-plasmic-name={"desc5"}
                data-plasmic-override={overrides.desc5}
                className={classNames(
                  projectcss.all,
                  projectcss.p,
                  projectcss.__wab_text,
                  sty.desc5
                )}
              >
                <React.Fragment>
                  <React.Fragment>{""}</React.Fragment>
                  {
                    <PlasmicLink__
                      aria-label={"Go to login page"}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__qvVkD
                      )}
                      component={Link}
                      href={`/login`}
                      legacyBehavior={false}
                      platform={"nextjs"}
                      title={"Go to login page"}
                    >
                      {"Log into your account"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>
                    {", click on Mail \u203a Support & Customer Service."}
                  </React.Fragment>
                </React.Fragment>
              </p>
              <p
                data-plasmic-name={"desc6"}
                data-plasmic-override={overrides.desc6}
                className={classNames(
                  projectcss.all,
                  projectcss.p,
                  projectcss.__wab_text,
                  sty.desc6
                )}
              >
                {hasVariant(globalVariants, "mobile", "tabletPortrait") ? (
                  <React.Fragment>
                    <React.Fragment>{"Email: "}</React.Fragment>
                    {
                      <PlasmicLink__
                        aria-label={"Mail our sales department"}
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__go6Jr
                        )}
                        component={Link}
                        href={"mailto:support@myevaluations.com"}
                        legacyBehavior={false}
                        platform={"nextjs"}
                      >
                        {hasVariant(globalVariants, "mobile", "tabletPortrait")
                          ? "support@myevaluations.com"
                          : "support@myevaluations.com"}
                      </PlasmicLink__>
                    }
                    <React.Fragment>{"\nPhone: "}</React.Fragment>
                    {
                      <PlasmicLink__
                        aria-label={"Call us"}
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__rtLxE
                        )}
                        component={Link}
                        href={"tel:866-422-0554"}
                        legacyBehavior={false}
                        platform={"nextjs"}
                      >
                        {hasVariant(globalVariants, "mobile", "tabletPortrait")
                          ? "(866) 422-0554"
                          : "(866) 422-0554"}
                      </PlasmicLink__>
                    }
                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <React.Fragment>{"Email: "}</React.Fragment>
                    {
                      <PlasmicLink__
                        aria-label={"Mail our sales department"}
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__go6Jr
                        )}
                        component={Link}
                        href={"mailto:support@myevaluations.com"}
                        legacyBehavior={false}
                        platform={"nextjs"}
                      >
                        {hasVariant(globalVariants, "mobile", "tabletPortrait")
                          ? "support@myevaluations.com"
                          : "support@myevaluations.com"}
                      </PlasmicLink__>
                    }
                    <React.Fragment>{"\nPhone: "}</React.Fragment>
                    {
                      <PlasmicLink__
                        aria-label={"Call us"}
                        className={classNames(
                          projectcss.all,
                          projectcss.a,
                          projectcss.__wab_text,
                          projectcss.plasmic_default__inline,
                          sty.link__rtLxE
                        )}
                        component={Link}
                        href={"tel:866-422-0554"}
                        legacyBehavior={false}
                        platform={"nextjs"}
                      >
                        {hasVariant(globalVariants, "mobile", "tabletPortrait")
                          ? "(866) 422-0554"
                          : "(866) 422-0554"}
                      </PlasmicLink__>
                    }
                    <React.Fragment>{""}</React.Fragment>
                  </React.Fragment>
                )}
              </p>
              <div
                data-plasmic-name={"desc7"}
                data-plasmic-override={overrides.desc7}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.desc7
                )}
              >
                {"Available 365 days a year, 7 days a week, 24 hours a day."}
              </div>
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"company"}
          data-plasmic-override={overrides.company}
          className={classNames(projectcss.all, sty.company)}
        >
          {(
            hasVariant(globalVariants, "mobile", "tabletPortrait")
              ? true
              : false
          ) ? (
            <div
              data-plasmic-name={"icon5"}
              data-plasmic-override={overrides.icon5}
              className={classNames(projectcss.all, sty.icon5)}
            >
              <PlasmicImg__
                alt={""}
                className={classNames(sty.img__pwiLs)}
                displayHeight={"24px"}
                displayMaxHeight={"none"}
                displayMaxWidth={"100%"}
                displayMinHeight={"0"}
                displayMinWidth={"0"}
                displayWidth={"24px"}
                loader={"plasmic"}
                loading={"lazy"}
                src={{
                  src: "https://site-assets.plasmic.app/1f1835047538b9318fc2b819a2227b4e.svg",
                  fullWidth: 24,
                  fullHeight: 24,
                  aspectRatio: 1
                }}
              />
            </div>
          ) : null}
          <div
            data-plasmic-name={"text"}
            data-plasmic-override={overrides.text}
            className={classNames(projectcss.all, sty.text)}
          >
            <h5
              data-plasmic-name={"title4"}
              data-plasmic-override={overrides.title4}
              className={classNames(
                projectcss.all,
                projectcss.h5,
                projectcss.__wab_text,
                sty.title4
              )}
            >
              {"Company"}
            </h5>
            <div
              data-plasmic-name={"paragraph3"}
              data-plasmic-override={overrides.paragraph3}
              className={classNames(projectcss.all, sty.paragraph3)}
            >
              <div
                data-plasmic-name={"desc4"}
                data-plasmic-override={overrides.desc4}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.desc4
                )}
              >
                {"MyEvaluations.com"}
              </div>
              <div
                data-plasmic-name={"desc8"}
                data-plasmic-override={overrides.desc8}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.desc8
                )}
              >
                {
                  "Physical Mailing Address:\n1159 Second Avenue, Suite 226\nNew York, NY 10065"
                }
              </div>
              <p
                data-plasmic-name={"desc9"}
                data-plasmic-override={overrides.desc9}
                className={classNames(
                  projectcss.all,
                  projectcss.p,
                  projectcss.__wab_text,
                  sty.desc9
                )}
              >
                <React.Fragment>
                  <React.Fragment>{"Email: "}</React.Fragment>
                  {
                    <PlasmicLink__
                      aria-label={"Mail our sales department"}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__mliyE
                      )}
                      component={Link}
                      href={"mailto:sales@myevaluations.com"}
                      legacyBehavior={false}
                      platform={"nextjs"}
                    >
                      {"sales@myevaluations.com"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{"\nPhone: "}</React.Fragment>
                  {
                    <PlasmicLink__
                      aria-label={"Call us"}
                      className={classNames(
                        projectcss.all,
                        projectcss.a,
                        projectcss.__wab_text,
                        projectcss.plasmic_default__inline,
                        sty.link__kugEl
                      )}
                      component={Link}
                      href={"tel:866-422-0554"}
                      legacyBehavior={false}
                      platform={"nextjs"}
                    >
                      {"(866) 422-0554"}
                    </PlasmicLink__>
                  }
                  <React.Fragment>{""}</React.Fragment>
                </React.Fragment>
              </p>
            </div>
          </div>
          {false ? (
            <div
              data-plasmic-name={"icon3"}
              data-plasmic-override={overrides.icon3}
              className={classNames(projectcss.all, sty.icon3)}
            >
              <div
                data-plasmic-name={"layout112"}
                data-plasmic-override={overrides.layout112}
                className={classNames(projectcss.all, sty.layout112)}
              >
                <Group2Icon
                  className={classNames(projectcss.all, sty.svg__gw4Rc)}
                  role={"img"}
                />
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  formModal: [
    "formModal",
    "fill",
    "top",
    "header",
    "left",
    "link",
    "dialogClose",
    "modalCloseButton",
    "intro",
    "title",
    "desc",
    "send",
    "contactForm",
    "form",
    "inputsRow",
    "nameWorkCol",
    "nameProvider",
    "nameInput",
    "nameLabel",
    "name",
    "nameErrorContainer",
    "error",
    "emailProvider",
    "emailInput",
    "emailLabel",
    "email",
    "emailErrorContainer",
    "error2",
    "institutionPhoneCol",
    "institutionProvider",
    "institutionInput",
    "institutionLabels",
    "label4",
    "label5",
    "institution",
    "institutionErrorContainer",
    "error5",
    "phoneProvider",
    "phoneInput",
    "label6",
    "label7",
    "label8",
    "phone",
    "phoneErrorContainer",
    "error6",
    "messageProvider",
    "messageTextarea",
    "messageLabel",
    "label10",
    "message",
    "messageErrorContainer",
    "error3",
    "sendMessageBtn",
    "spinnerIcon",
    "footer",
    "sales",
    "icon2",
    "text8",
    "title2",
    "paragraph",
    "desc2",
    "desc3",
    "button2",
    "support",
    "icon4",
    "text9",
    "title5",
    "paragraph2",
    "desc5",
    "desc6",
    "desc7",
    "company",
    "icon5",
    "text",
    "title4",
    "paragraph3",
    "desc4",
    "desc8",
    "desc9",
    "icon3",
    "layout112"
  ],
  fill: [
    "fill",
    "top",
    "header",
    "left",
    "link",
    "dialogClose",
    "modalCloseButton",
    "intro",
    "title",
    "desc",
    "send",
    "contactForm",
    "form",
    "inputsRow",
    "nameWorkCol",
    "nameProvider",
    "nameInput",
    "nameLabel",
    "name",
    "nameErrorContainer",
    "error",
    "emailProvider",
    "emailInput",
    "emailLabel",
    "email",
    "emailErrorContainer",
    "error2",
    "institutionPhoneCol",
    "institutionProvider",
    "institutionInput",
    "institutionLabels",
    "label4",
    "label5",
    "institution",
    "institutionErrorContainer",
    "error5",
    "phoneProvider",
    "phoneInput",
    "label6",
    "label7",
    "label8",
    "phone",
    "phoneErrorContainer",
    "error6",
    "messageProvider",
    "messageTextarea",
    "messageLabel",
    "label10",
    "message",
    "messageErrorContainer",
    "error3",
    "sendMessageBtn",
    "spinnerIcon"
  ],
  top: [
    "top",
    "header",
    "left",
    "link",
    "dialogClose",
    "modalCloseButton",
    "intro",
    "title",
    "desc"
  ],
  header: ["header", "left", "link", "dialogClose", "modalCloseButton"],
  left: ["left", "link"],
  link: ["link"],
  dialogClose: ["dialogClose", "modalCloseButton"],
  modalCloseButton: ["modalCloseButton"],
  intro: ["intro", "title", "desc"],
  title: ["title"],
  desc: ["desc"],
  send: [
    "send",
    "contactForm",
    "form",
    "inputsRow",
    "nameWorkCol",
    "nameProvider",
    "nameInput",
    "nameLabel",
    "name",
    "nameErrorContainer",
    "error",
    "emailProvider",
    "emailInput",
    "emailLabel",
    "email",
    "emailErrorContainer",
    "error2",
    "institutionPhoneCol",
    "institutionProvider",
    "institutionInput",
    "institutionLabels",
    "label4",
    "label5",
    "institution",
    "institutionErrorContainer",
    "error5",
    "phoneProvider",
    "phoneInput",
    "label6",
    "label7",
    "label8",
    "phone",
    "phoneErrorContainer",
    "error6",
    "messageProvider",
    "messageTextarea",
    "messageLabel",
    "label10",
    "message",
    "messageErrorContainer",
    "error3",
    "sendMessageBtn",
    "spinnerIcon"
  ],
  contactForm: [
    "contactForm",
    "form",
    "inputsRow",
    "nameWorkCol",
    "nameProvider",
    "nameInput",
    "nameLabel",
    "name",
    "nameErrorContainer",
    "error",
    "emailProvider",
    "emailInput",
    "emailLabel",
    "email",
    "emailErrorContainer",
    "error2",
    "institutionPhoneCol",
    "institutionProvider",
    "institutionInput",
    "institutionLabels",
    "label4",
    "label5",
    "institution",
    "institutionErrorContainer",
    "error5",
    "phoneProvider",
    "phoneInput",
    "label6",
    "label7",
    "label8",
    "phone",
    "phoneErrorContainer",
    "error6",
    "messageProvider",
    "messageTextarea",
    "messageLabel",
    "label10",
    "message",
    "messageErrorContainer",
    "error3",
    "sendMessageBtn",
    "spinnerIcon"
  ],
  form: [
    "form",
    "inputsRow",
    "nameWorkCol",
    "nameProvider",
    "nameInput",
    "nameLabel",
    "name",
    "nameErrorContainer",
    "error",
    "emailProvider",
    "emailInput",
    "emailLabel",
    "email",
    "emailErrorContainer",
    "error2",
    "institutionPhoneCol",
    "institutionProvider",
    "institutionInput",
    "institutionLabels",
    "label4",
    "label5",
    "institution",
    "institutionErrorContainer",
    "error5",
    "phoneProvider",
    "phoneInput",
    "label6",
    "label7",
    "label8",
    "phone",
    "phoneErrorContainer",
    "error6",
    "messageProvider",
    "messageTextarea",
    "messageLabel",
    "label10",
    "message",
    "messageErrorContainer",
    "error3",
    "sendMessageBtn",
    "spinnerIcon"
  ],
  inputsRow: [
    "inputsRow",
    "nameWorkCol",
    "nameProvider",
    "nameInput",
    "nameLabel",
    "name",
    "nameErrorContainer",
    "error",
    "emailProvider",
    "emailInput",
    "emailLabel",
    "email",
    "emailErrorContainer",
    "error2",
    "institutionPhoneCol",
    "institutionProvider",
    "institutionInput",
    "institutionLabels",
    "label4",
    "label5",
    "institution",
    "institutionErrorContainer",
    "error5",
    "phoneProvider",
    "phoneInput",
    "label6",
    "label7",
    "label8",
    "phone",
    "phoneErrorContainer",
    "error6"
  ],
  nameWorkCol: [
    "nameWorkCol",
    "nameProvider",
    "nameInput",
    "nameLabel",
    "name",
    "nameErrorContainer",
    "error",
    "emailProvider",
    "emailInput",
    "emailLabel",
    "email",
    "emailErrorContainer",
    "error2"
  ],
  nameProvider: [
    "nameProvider",
    "nameInput",
    "nameLabel",
    "name",
    "nameErrorContainer",
    "error"
  ],
  nameInput: ["nameInput", "nameLabel", "name", "nameErrorContainer", "error"],
  nameLabel: ["nameLabel"],
  name: ["name"],
  nameErrorContainer: ["nameErrorContainer", "error"],
  error: ["error"],
  emailProvider: [
    "emailProvider",
    "emailInput",
    "emailLabel",
    "email",
    "emailErrorContainer",
    "error2"
  ],
  emailInput: [
    "emailInput",
    "emailLabel",
    "email",
    "emailErrorContainer",
    "error2"
  ],
  emailLabel: ["emailLabel"],
  email: ["email"],
  emailErrorContainer: ["emailErrorContainer", "error2"],
  error2: ["error2"],
  institutionPhoneCol: [
    "institutionPhoneCol",
    "institutionProvider",
    "institutionInput",
    "institutionLabels",
    "label4",
    "label5",
    "institution",
    "institutionErrorContainer",
    "error5",
    "phoneProvider",
    "phoneInput",
    "label6",
    "label7",
    "label8",
    "phone",
    "phoneErrorContainer",
    "error6"
  ],
  institutionProvider: [
    "institutionProvider",
    "institutionInput",
    "institutionLabels",
    "label4",
    "label5",
    "institution",
    "institutionErrorContainer",
    "error5"
  ],
  institutionInput: [
    "institutionInput",
    "institutionLabels",
    "label4",
    "label5",
    "institution",
    "institutionErrorContainer",
    "error5"
  ],
  institutionLabels: ["institutionLabels", "label4", "label5"],
  label4: ["label4"],
  label5: ["label5"],
  institution: ["institution"],
  institutionErrorContainer: ["institutionErrorContainer", "error5"],
  error5: ["error5"],
  phoneProvider: [
    "phoneProvider",
    "phoneInput",
    "label6",
    "label7",
    "label8",
    "phone",
    "phoneErrorContainer",
    "error6"
  ],
  phoneInput: [
    "phoneInput",
    "label6",
    "label7",
    "label8",
    "phone",
    "phoneErrorContainer",
    "error6"
  ],
  label6: ["label6", "label7", "label8"],
  label7: ["label7"],
  label8: ["label8"],
  phone: ["phone"],
  phoneErrorContainer: ["phoneErrorContainer", "error6"],
  error6: ["error6"],
  messageProvider: [
    "messageProvider",
    "messageTextarea",
    "messageLabel",
    "label10",
    "message",
    "messageErrorContainer",
    "error3"
  ],
  messageTextarea: [
    "messageTextarea",
    "messageLabel",
    "label10",
    "message",
    "messageErrorContainer",
    "error3"
  ],
  messageLabel: ["messageLabel", "label10"],
  label10: ["label10"],
  message: ["message"],
  messageErrorContainer: ["messageErrorContainer", "error3"],
  error3: ["error3"],
  sendMessageBtn: ["sendMessageBtn", "spinnerIcon"],
  spinnerIcon: ["spinnerIcon"],
  footer: [
    "footer",
    "sales",
    "icon2",
    "text8",
    "title2",
    "paragraph",
    "desc2",
    "desc3",
    "button2",
    "support",
    "icon4",
    "text9",
    "title5",
    "paragraph2",
    "desc5",
    "desc6",
    "desc7",
    "company",
    "icon5",
    "text",
    "title4",
    "paragraph3",
    "desc4",
    "desc8",
    "desc9",
    "icon3",
    "layout112"
  ],
  sales: [
    "sales",
    "icon2",
    "text8",
    "title2",
    "paragraph",
    "desc2",
    "desc3",
    "button2"
  ],
  icon2: ["icon2"],
  text8: ["text8", "title2", "paragraph", "desc2", "desc3", "button2"],
  title2: ["title2"],
  paragraph: ["paragraph", "desc2", "desc3"],
  desc2: ["desc2"],
  desc3: ["desc3"],
  button2: ["button2"],
  support: [
    "support",
    "icon4",
    "text9",
    "title5",
    "paragraph2",
    "desc5",
    "desc6",
    "desc7"
  ],
  icon4: ["icon4"],
  text9: ["text9", "title5", "paragraph2", "desc5", "desc6", "desc7"],
  title5: ["title5"],
  paragraph2: ["paragraph2", "desc5", "desc6", "desc7"],
  desc5: ["desc5"],
  desc6: ["desc6"],
  desc7: ["desc7"],
  company: [
    "company",
    "icon5",
    "text",
    "title4",
    "paragraph3",
    "desc4",
    "desc8",
    "desc9",
    "icon3",
    "layout112"
  ],
  icon5: ["icon5"],
  text: ["text", "title4", "paragraph3", "desc4", "desc8", "desc9"],
  title4: ["title4"],
  paragraph3: ["paragraph3", "desc4", "desc8", "desc9"],
  desc4: ["desc4"],
  desc8: ["desc8"],
  desc9: ["desc9"],
  icon3: ["icon3", "layout112"],
  layout112: ["layout112"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  formModal: "div";
  fill: "div";
  top: "div";
  header: "header";
  left: "div";
  link: "h4";
  dialogClose: typeof DialogClose;
  modalCloseButton: typeof ModalCloseButton;
  intro: "div";
  title: "h2";
  desc: "p";
  send: typeof ApiMutationProvider;
  contactForm: typeof FormProvider;
  form: "form";
  inputsRow: "div";
  nameWorkCol: "div";
  nameProvider: typeof FormControlProvider;
  nameInput: "div";
  nameLabel: "div";
  name: typeof TextInput;
  nameErrorContainer: "div";
  error: "span";
  emailProvider: typeof FormControlProvider;
  emailInput: "div";
  emailLabel: "div";
  email: typeof TextInput;
  emailErrorContainer: "div";
  error2: "span";
  institutionPhoneCol: "div";
  institutionProvider: typeof FormControlProvider;
  institutionInput: "div";
  institutionLabels: "div";
  label4: "div";
  label5: "label";
  institution: typeof TextInput;
  institutionErrorContainer: "div";
  error5: "span";
  phoneProvider: typeof FormControlProvider;
  phoneInput: "div";
  label6: "div";
  label7: "div";
  label8: "label";
  phone: typeof TextInput;
  phoneErrorContainer: "div";
  error6: "span";
  messageProvider: typeof FormControlProvider;
  messageTextarea: "div";
  messageLabel: "div";
  label10: "div";
  message: typeof Textarea;
  messageErrorContainer: "div";
  error3: "span";
  sendMessageBtn: typeof Button;
  spinnerIcon: typeof SpinnerIcon;
  footer: "div";
  sales: "div";
  icon2: "div";
  text8: "div";
  title2: "h5";
  paragraph: "div";
  desc2: "p";
  desc3: "p";
  button2: typeof Button;
  support: "div";
  icon4: "div";
  text9: "div";
  title5: "h5";
  paragraph2: "div";
  desc5: "p";
  desc6: "p";
  desc7: "div";
  company: "div";
  icon5: "div";
  text: "div";
  title4: "h5";
  paragraph3: "div";
  desc4: "div";
  desc8: "div";
  desc9: "p";
  icon3: "div";
  layout112: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicContactModalForm__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicContactModalForm__VariantsArgs;
    args?: PlasmicContactModalForm__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicContactModalForm__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicContactModalForm__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicContactModalForm__ArgProps,
          internalVariantPropNames: PlasmicContactModalForm__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicContactModalForm__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "formModal") {
    func.displayName = "PlasmicContactModalForm";
  } else {
    func.displayName = `PlasmicContactModalForm.${nodeName}`;
  }
  return func;
}

export const PlasmicContactModalForm = Object.assign(
  // Top-level PlasmicContactModalForm renders the root element
  makeNodeComponent("formModal"),
  {
    // Helper components rendering sub-elements
    fill: makeNodeComponent("fill"),
    top: makeNodeComponent("top"),
    header: makeNodeComponent("header"),
    left: makeNodeComponent("left"),
    link: makeNodeComponent("link"),
    dialogClose: makeNodeComponent("dialogClose"),
    modalCloseButton: makeNodeComponent("modalCloseButton"),
    intro: makeNodeComponent("intro"),
    title: makeNodeComponent("title"),
    desc: makeNodeComponent("desc"),
    send: makeNodeComponent("send"),
    contactForm: makeNodeComponent("contactForm"),
    form: makeNodeComponent("form"),
    inputsRow: makeNodeComponent("inputsRow"),
    nameWorkCol: makeNodeComponent("nameWorkCol"),
    nameProvider: makeNodeComponent("nameProvider"),
    nameInput: makeNodeComponent("nameInput"),
    nameLabel: makeNodeComponent("nameLabel"),
    _name: makeNodeComponent("name"),
    nameErrorContainer: makeNodeComponent("nameErrorContainer"),
    error: makeNodeComponent("error"),
    emailProvider: makeNodeComponent("emailProvider"),
    emailInput: makeNodeComponent("emailInput"),
    emailLabel: makeNodeComponent("emailLabel"),
    email: makeNodeComponent("email"),
    emailErrorContainer: makeNodeComponent("emailErrorContainer"),
    error2: makeNodeComponent("error2"),
    institutionPhoneCol: makeNodeComponent("institutionPhoneCol"),
    institutionProvider: makeNodeComponent("institutionProvider"),
    institutionInput: makeNodeComponent("institutionInput"),
    institutionLabels: makeNodeComponent("institutionLabels"),
    label4: makeNodeComponent("label4"),
    label5: makeNodeComponent("label5"),
    institution: makeNodeComponent("institution"),
    institutionErrorContainer: makeNodeComponent("institutionErrorContainer"),
    error5: makeNodeComponent("error5"),
    phoneProvider: makeNodeComponent("phoneProvider"),
    phoneInput: makeNodeComponent("phoneInput"),
    label6: makeNodeComponent("label6"),
    label7: makeNodeComponent("label7"),
    label8: makeNodeComponent("label8"),
    phone: makeNodeComponent("phone"),
    phoneErrorContainer: makeNodeComponent("phoneErrorContainer"),
    error6: makeNodeComponent("error6"),
    messageProvider: makeNodeComponent("messageProvider"),
    messageTextarea: makeNodeComponent("messageTextarea"),
    messageLabel: makeNodeComponent("messageLabel"),
    label10: makeNodeComponent("label10"),
    message: makeNodeComponent("message"),
    messageErrorContainer: makeNodeComponent("messageErrorContainer"),
    error3: makeNodeComponent("error3"),
    sendMessageBtn: makeNodeComponent("sendMessageBtn"),
    spinnerIcon: makeNodeComponent("spinnerIcon"),
    footer: makeNodeComponent("footer"),
    sales: makeNodeComponent("sales"),
    icon2: makeNodeComponent("icon2"),
    text8: makeNodeComponent("text8"),
    title2: makeNodeComponent("title2"),
    paragraph: makeNodeComponent("paragraph"),
    desc2: makeNodeComponent("desc2"),
    desc3: makeNodeComponent("desc3"),
    button2: makeNodeComponent("button2"),
    support: makeNodeComponent("support"),
    icon4: makeNodeComponent("icon4"),
    text9: makeNodeComponent("text9"),
    title5: makeNodeComponent("title5"),
    paragraph2: makeNodeComponent("paragraph2"),
    desc5: makeNodeComponent("desc5"),
    desc6: makeNodeComponent("desc6"),
    desc7: makeNodeComponent("desc7"),
    company: makeNodeComponent("company"),
    icon5: makeNodeComponent("icon5"),
    text: makeNodeComponent("text"),
    title4: makeNodeComponent("title4"),
    paragraph3: makeNodeComponent("paragraph3"),
    desc4: makeNodeComponent("desc4"),
    desc8: makeNodeComponent("desc8"),
    desc9: makeNodeComponent("desc9"),
    icon3: makeNodeComponent("icon3"),
    layout112: makeNodeComponent("layout112"),

    // Metadata about props expected for PlasmicContactModalForm
    internalVariantProps: PlasmicContactModalForm__VariantProps,
    internalArgProps: PlasmicContactModalForm__ArgProps
  }
);

export default PlasmicContactModalForm;
/* prettier-ignore-end */
